import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import UserTab from "./user/UserTab";
import { Person as PersonIcon, Storage } from "@mui/icons-material";
import PeopleIcon from "@mui/icons-material/People";
import Vehicle from "../../vehicle/Vehicle";
import Mechanics from "../../masterData/mechanic/Mechanics";
import { Container, Paper } from "@mui/material";
import { Grid } from "@mui/material";
import CompanyProfile from "../CompanyProfile";
import BusinessIcon from "@mui/icons-material/Business";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import MasterData from "../../masterData/MasterData";
import { useNavigate, useParams } from "react-router-dom";
import { checkModuleAccess } from "../../../components/Sidebar";
import { usePlanStatus } from "../../../hooks/usePlanStatus";
import { tabType } from "../../../types/operationType";

interface TabPanelProps {
  children?: React.ReactNode;
  tabLabel: string;
  currentTab: string;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, tabLabel, currentTab, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={currentTab !== tabLabel}
      id={`simple-tabpanel-${tabLabel}`}
      aria-labelledby={`simple-tab-${tabLabel}`}
      {...other}
    >
      {currentTab === tabLabel && (
        <Box sx={{ p: 1, height: "100%" }}>{children}</Box>
      )}
    </div>
  );
}

function a11yProps(tabLabel: string) {
  return {
    id: `simple-tab-${tabLabel}`,
    "aria-controls": `simple-tabpanel-${tabLabel}`,
  };
}

export default function TabComponent() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = React.useState(tab || "profile");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    navigate(`/${newValue}`);
    setCurrentTab(newValue);
  };

  const tabStyles = {
    minHeight: "24px",
    fontSize: "0.65rem",
    fontWeight: "500",
    padding: "6px 12px",
  };

  const { planStatus } = usePlanStatus();

  const {
    hasCompanyAccess,
    hasUserAccess,
    hasVehicleAccess,
    hasMasterDataAccess,
  } = React.useMemo(() => {
    const permissions = planStatus?.permissions;
    return {
      hasCompanyAccess: permissions?.canViewCompany,
      hasUserAccess: permissions?.canViewUsers,
      hasVehicleAccess: permissions?.canViewVehicle,
      hasMasterDataAccess: checkModuleAccess(permissions, tabType.MASTER_DATA),
    };
  }, [planStatus?.permissions]);

  return (
    <Container maxWidth="lg" sx={{ backgroundColor: "white", minHeight: "100%" }}>
      <Grid item xs={12}>
        <Box>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={currentTab}
              onChange={handleChange}
              sx={{ "& .MuiTab-root": tabStyles }}
            >
              {hasCompanyAccess && (
                <Tab
                  icon={<BusinessIcon fontSize="small" />}
                  label="Profile"
                  value="profile"
                  {...a11yProps("profile")}
                />
              )}
              {hasUserAccess && (
                <Tab
                  icon={<PeopleIcon fontSize="small" />}
                  label="User Access"
                  value="company-staff"
                  {...a11yProps("company-staff")}
                />
              )}
              {hasVehicleAccess && (
                <Tab
                  icon={<DirectionsBusIcon fontSize="small" />}
                  label="Vehicles"
                  value="vehicles"
                  {...a11yProps("vehicles")}
                />
              )}
              {hasMasterDataAccess && (
                <Tab
                  icon={<Storage />}
                  label="Global Master"
                  value="master-data"
                  {...a11yProps("master-data")}
                />
              )}
            </Tabs>
          </Box>
          <CustomTabPanel currentTab={currentTab} tabLabel="profile">
            <CompanyProfile />
          </CustomTabPanel>
          <CustomTabPanel currentTab={currentTab} tabLabel="company-staff">
            <UserTab />
          </CustomTabPanel>
          <CustomTabPanel currentTab={currentTab} tabLabel="vehicles">
            <Vehicle />
          </CustomTabPanel>
          <CustomTabPanel currentTab={currentTab} tabLabel="master-data">
            <MasterData />
          </CustomTabPanel>
        </Box>
      </Grid>
    </Container>
  );
}
